module.exports = {
	"data": {
		"postBySlug": {
			"html": "<h3 id=\"the-green-book-should-be-read-together-with-the-code-of-conduct-as-they-form-part-of-a-suite-of-communications-covering-governance-the-code-of-conduct-outlines-our-commitment-to-doing-business-ethically-lawfully-and-with-integrity\"><a href=\"#the-green-book-should-be-read-together-with-the-code-of-conduct-as-they-form-part-of-a-suite-of-communications-covering-governance-the-code-of-conduct-outlines-our-commitment-to-doing-business-ethically-lawfully-and-with-integrity\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>The Green Book should be read together with the Code of Conduct as they form part of a suite of communications covering governance. The Code of Conduct outlines our commitment to doing business ethically, lawfully and with integrity.</h3>\n<p>The Code of Conduct is a public document that sets out what we expect from every individual working for and with DMGT and its Operating Companies anywhere in the world, and demonstrates to our customers, business partners, suppliers, shareholders and other stakeholders the values and principles we uphold both internally and externally. </p>\n<h4 id=\"key-operating-principles\"><a href=\"#key-operating-principles\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a> Key operating principles:</h4>\n<ul>\n<li>\n<p>The Code of Conduct applies to all employees across the Group and to anyone working on behalf of DMGT and its Operating Companies, including agents and contractors.</p>\n</li>\n<li>\n<p>Operating Companies may have their own code of conduct, which should be consistent with the values set out in DMGT’s Code of Conduct.</p>\n</li>\n</ul>\n<p>Where an inconsistency arises, DMGT’s Code of Conduct must take precedence.</p>\n<hr>\n<p>Contacts:\n<br>\nAnnie Edwards, Global Head of HR (<a href=\"mailto:annie.edwards@dmgt.com\">annie.edwards@dmgt.com</a>)\n<br>\nCatherine Lye, Senior Risk Manager (<a href=\"mailto:catherine.lye@dmgt.com\">catherine.lye@dmgt.com</a>)</p>",
			"timeToRead": 1,
			"excerpt": "The Green Book should be read together with the Code of Conduct as they form part of a suite of communications covering governance. The Code...",
			"frontmatter": {
				"title": "Lesson Three - Code of Conduct",
				"cover": null,
				"date": null,
				"category": null,
				"tags": null
			}
		},
		"tableOfContents": {
			"chapters": [
				{
					"title": "1. Main Chapter",
					"entries": null,
					"chapters": [
						{
							"title": "1.1 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_one.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/1-dmgt-at-a-glance"
											},
											"frontmatter": {
												"title": "1. DMGT at a glance "
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "1.1.1 Sub-subchapter",
									"entries": [
										{
											"entry": {
												"id": "/opt/build/repo/content/lessons/lesson_two.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/lesson-two-scope-and-responsibilities"
													},
													"frontmatter": {
														"title": "Lesson Two - Scope and responsibilities"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/opt/build/repo/content/lessons/lesson_three.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/lesson-three-code-of-conduct"
													},
													"frontmatter": {
														"title": "Lesson Three - Code of Conduct"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "1.2 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_four.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/lesson-four"
											},
											"frontmatter": {
												"title": "Lesson Four"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "2. Main Chapter",
					"entries": null,
					"chapters": [
						{
							"title": "2.1 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_five.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/lesson-five"
											},
											"frontmatter": {
												"title": "Lesson Five"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "3. Main Chapter",
					"entries": [
						{
							"entry": {
								"id": "/opt/build/repo/content/lessons/lesson_six.md absPath of file",
								"childMarkdownRemark": {
									"fields": {
										"slug": "/lesson-six"
									},
									"frontmatter": {
										"title": "Lesson Six"
									}
								}
							}
						}
					],
					"chapters": null
				}
			]
		}
	},
	"pathContext": {
		"slug": "/lesson-three-code-of-conduct"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/lesson-three-code-of-conduct.json
// module id = 411
// module chunks = 109424322855541